/*
 * Human-readable lines for the import report banner. Anything Word can do
 * that free CKEditor can't represent is skipped and listed here.
 */

const MESSAGES = {
    IMAGE_UNSUPPORTED: (n) => `${n} image${n > 1 ? 's' : ''} in an unsupported format (such as EMF/WMF/TIFF) ${n > 1 ? 'were' : 'was'} skipped.`,
    IMAGE_TOO_LARGE: (n) => `${n} image${n > 1 ? 's were' : ' was'} larger than 15 MB and skipped.`,
    IMAGE_LIMIT: () => 'The document has too many images; some were skipped.',
    IMAGE_MISSING: (n) => `${n} image${n > 1 ? 's' : ''} could not be found in the file.`,
    IMAGE_LINKED: (n) => `${n} linked (not embedded) image${n > 1 ? 's were' : ' was'} skipped.`,
    IMAGE_UPLOAD_FAILED: (n) => `${n} image${n > 1 ? 's' : ''} failed to upload and ${n > 1 ? 'were' : 'was'} left out.`,
    SHAPE_SKIPPED: (n) => `${n} shape${n > 1 ? 's' : ''} or drawing${n > 1 ? 's were' : ' was'} skipped.`,
    TEXTBOX_SKIPPED: (n) => `${n} text box${n > 1 ? 'es were' : ' was'} skipped.`,
    CHART_SKIPPED: (n) => `${n} chart${n > 1 ? 's were' : ' was'} skipped.`,
    EQUATION_PARTIAL: (n) => `${n} equation${n > 1 ? 's' : ''} used Word-only features that were simplified.`,
    FOOTNOTE_TEXT_SKIPPED: () => 'Footnote and endnote text was not imported (the reference numbers were kept).',
    LINK_REMOVED: (n) => `${n} link${n > 1 ? 's' : ''} to unsupported destinations ${n > 1 ? 'were' : 'was'} kept as plain text.`,
    SYMBOL_UNMAPPED: () => 'Some special symbol characters could not be converted.',
    NUMBERING_FORMAT: () => 'Some list numbering styles were shown as plain numbers.',
    TABLE_TOO_DEEP: () => 'Very deeply nested tables were flattened.',
    ALTCHUNK_SKIPPED: () => 'Embedded documents inside the file were skipped.',
};

/**
 * @param {{code: string, count: number}[]} warnings
 * @returns {string[]}
 */
export function describeWarnings(warnings) {
    return (warnings || [])
        .filter((w) => MESSAGES[w.code])
        .map((w) => MESSAGES[w.code](w.count || 1));
}
